import axios from 'axios'
import Vue from 'vue'

let files = new Vue({
  data () {
    return {
      documentExtensionsAllowed: ['doc', 'docx', 'gif', 'jpg', 'jpeg', 'pdf', 'png', 'ppt', 'pptx', 'txt', 'xls', 'xlsx', 'zip'],
      fileSizeAllowed: 12 * 1024 * 1024, // MEGABYTES
      imageExtensionsAllowed: ['gif', 'jpg', 'jpeg', 'png']
    }
  },

  methods: {
    allowedFileExtension (fileName, fileType) {
      let extension = fileName.split('.').pop()
      return fileType === 'document'
        ? this.documentExtensionsAllowed.find(ext => ext === extension) !== undefined
        : fileType === 'image'
          ? this.imageExtensionsAllowed.find(ext => ext === extension) !== undefined
          : false
    },

    allowedFileSize (fileSize) {
      return fileSize <= this.fileSizeAllowed
    },

    downloadCsv (data, fileName = null) {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      let name = fileName === null ? 'download' : fileName
      link.href = url
      link.setAttribute('download', `${name}.csv`, 'text/html; charset=UTF-8')
      document.body.appendChild(link)
      link.click()
    },

    downloadFile (fetchedFile, fileName) {
      const url = window.URL.createObjectURL(new Blob([fetchedFile.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      this.$alerts.closeAlert()
      this.$alerts.pushAlert('mContentNodeBlockDocument', 'showDownloadState', 'downloaded', 'a-alert-success')
    },

    getFile (storedFile) {
      this.$alerts.closeAlert()
      this.$alerts.pushAlert('mContentNodeBlockDocument', 'showDownloadState', 'downloading', 'a-alert-loading')
      axios({
        headers: { Authorization: '' },
        url: storedFile,
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        let fileName = storedFile.substring(storedFile.lastIndexOf('/') + 1)
        this.downloadFile(response, fileName)
      }).catch(error => {
        console.log(error)
        this.$alerts.closeAlert()
        this.$alerts.pushAlert('mContentNodeBlockDocument', 'showDownloadState', 'error', 'a-alert-danger')
      })
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$files = files
  }
}
